import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';

const RootRedirect = () => {
    const { data } = useGetCurrentUserQuery();

    if (data?.data?.role) {
        return <Navigate to={'/claire-2'} />;
    } 
    return <div className='flex flex-col w-full h-screen justify-center items-center'>
        <img className='w-24' src='/assets/admin/hotel-icon.svg' />
        <p className='text-xl text-black text-center mt-5'>Redirecting...</p>
        <p className='text-primary-light text-center mt-2'>Your time our priority!</p>
    </div>;

};

export default RootRedirect;
